// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kKKT3","col":"styles_col__1lHpn"};